import { CreateSDKConfig } from './api/types';
import RFIsApi from './api/RFIsApi';
import UsersApi from './api/UsersApi';
import WorkflowApi from './api/WorkflowApi';
import AdvancedSettingsApi from './api/AdvancedSettingsApi';
import CustomAttributeApi from './api/CustomAttributeApi';
import ExternalUsersApi from './api/ExternalUsersApi';
import RfiTypesApi from './api/RfiTypesApi';
import VirtualFoldersApi from './api/VirtualFoldersApi';

const createSDK = (config: CreateSDKConfig) => ({
  RFIs: RFIsApi(config),
  Users: UsersApi(config),
  Workflow: WorkflowApi(config),
  AdvancedSettings: AdvancedSettingsApi(config),
  CustomAttributes: CustomAttributeApi(config),
  ExternalUsers: ExternalUsersApi(config),
  RfiTypes: RfiTypesApi(config),
  VirtualFolders: VirtualFoldersApi(config),
});

export default createSDK;
